import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f73376a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 환급 신청은 왜")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "더낸세금", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("이 최고일까요? ")
const _hoisted_5 = { class: "heum-tax box" }
const _hoisted_6 = { class: "text-area" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 세무법인 혜움이 책임집니다. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 혜움은 26개 지점을 보유한 대형 세무법인입니다. 국세청, 대형 회계법인 출신 세무사 54명과 120명의 전문 인력을 보유하고 있습니다. ")
const _hoisted_9 = { class: "logo" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "tech box" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 업계 최고 기술력 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 정부기관과 투자자가 보증하는 국내 최고 세무 IT 연구소를 보유하고 있습니다. ")
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 상담 서비스 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 환급이 이루어지기까지 세무 전문가들이 도와드립니다. ")
const _hoisted_17 = { class: "security box" }
const _hoisted_18 = { class: "text-area" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 믿을 수 있는 개인정보 관리 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 가장 권위 있는 국제표준 정보보호경영시스템 ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "ISO 27001 인증", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("으로 ")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "개인정보 보호를 세계적 수준에 충족", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("하는 관리 체계를 갖추고 있습니다. ")
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "accuracy box" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 정확한 예상금액 조회 ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 환급 예상 금액과 실제 환급 되는 금액의 일치율이 국내 최고!! 조회만으로 ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "환급금을 정확하게 예측", -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode("할 수 있습니다. ")
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "quantity box" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 국내 최다 환급 건수 ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 국세청 신고 접수 기준 ")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "국내 최다 환급 신청", -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode("을 진행하고 있습니다. ")
const _hoisted_37 = ["src"]

import { ref, onMounted } from 'vue'

import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET, FONT_WEIGHT } from '@/styles/variables'
import HeumTaxLogo from '@/styles/icon/HeumTaxLogo.vue'
import { getImageUrl } from '@/utils/getImageUrl'

import { setAnimationObserver } from '../libs/observer'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingOvertax',
  setup(__props) {

const wrapper = ref()
const showAnimation = ref(false)

onMounted(() => {
  setAnimationObserver(wrapper.value, () => { showAnimation.value = true }, 0.2)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: "wrapper"
  }, [
    _createVNode(Text, {
      class: _normalizeClass(["title animation-show", { show: showAnimation.value }]),
      size: "64px",
      "mobile-size": "30px",
      "line-height": "1.25",
      weight: _unref(FONT_WEIGHT).bold,
      "text-align": "center",
      "word-break": "keep-all"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }, 8, ["class", "weight"]),
    _createElementVNode("div", {
      class: _normalizeClass(["info-boxes animation-show delay", { show: showAnimation.value }])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(Text, {
            size: "32px",
            "mobile-size": "14px",
            color: _unref(COLOR_SET).white,
            weight: _unref(FONT_WEIGHT).bold,
            "word-break": "keep-all"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["color", "weight"]),
          _createVNode(Text, {
            size: "24px",
            "mobile-size": "10px",
            color: _unref(COLOR_SET).white,
            "word-break": "keep-all"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(HeumTaxLogo)
        ]),
        _createElementVNode("img", {
          src: _unref(getImageUrl)('landing/tax_bg.png')
        }, null, 8, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(Text, {
          size: "32px",
          "mobile-size": "14px",
          weight: _unref(FONT_WEIGHT).bold
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["weight"]),
        _createVNode(Text, {
          size: "24px",
          "mobile-size": "10px",
          margin: "20px 0 36px 0",
          "mobile-margin": "8px 0 8px 0",
          "word-break": "keep-all"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createElementVNode("img", {
          src: _unref(getImageUrl)('landing/tech.png')
        }, null, 8, _hoisted_14)
      ]),
      _createElementVNode("div", {
        class: "counsel box",
        style: _normalizeStyle({'background-image': `url(${_unref(getImageUrl)('landing/counsel.png')})`})
      }, [
        _createVNode(Text, {
          size: "32px",
          "mobile-size": "14px",
          weight: _unref(FONT_WEIGHT).bold
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["weight"]),
        _createVNode(Text, {
          size: "24px",
          "mobile-size": "10px",
          "word-break": "keep-all"
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ], 4),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(Text, {
            size: "32px",
            "mobile-size": "14px",
            weight: _unref(FONT_WEIGHT).bold
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["weight"]),
          _createVNode(Text, {
            size: "24px",
            "mobile-size": "10px",
            class: "contents"
          }, {
            default: _withCtx(() => [
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _hoisted_24
            ]),
            _: 1
          })
        ]),
        _createElementVNode("img", {
          src: _unref(getImageUrl)('landing/iso.png')
        }, null, 8, _hoisted_25)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(Text, {
          size: "32px",
          "mobile-size": "14px",
          weight: _unref(FONT_WEIGHT).bold
        }, {
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        }, 8, ["weight"]),
        _createVNode(Text, {
          size: "24px",
          "mobile-size": "10px",
          margin: "20px 0 13px 0",
          "mobile-margin": "8px 0 8px 0",
          class: "contents"
        }, {
          default: _withCtx(() => [
            _hoisted_28,
            _hoisted_29,
            _hoisted_30
          ]),
          _: 1
        }),
        _createElementVNode("img", {
          src: _unref(getImageUrl)('landing/accuracy.png')
        }, null, 8, _hoisted_31)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(Text, {
          size: "32px",
          "mobile-size": "14px",
          weight: _unref(FONT_WEIGHT).bold
        }, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        }, 8, ["weight"]),
        _createVNode(Text, {
          size: "24px",
          "mobile-size": "10px",
          margin: "20px 0 40px 0",
          "mobile-margin": "8px 0 8px 0",
          class: "contents",
          "word-break": "keep-all"
        }, {
          default: _withCtx(() => [
            _hoisted_34,
            _hoisted_35,
            _hoisted_36
          ]),
          _: 1
        }),
        _createElementVNode("img", {
          src: _unref(getImageUrl)('landing/quantity.png')
        }, null, 8, _hoisted_37)
      ])
    ], 2)
  ], 512))
}
}

})